/**
 *
 * @param fields {StoreFormField[]}
 */
import StoreFormField from './FormField'

class StoreFormConfiguration {
  constructor (
    fields,
    legacy = {}
  ) {
    this.fields = fields
    this.legacy = legacy
  }

  toJSON () {
    const jsonProperties = this.fields
      .map(field => field.toJSONSchema())
      .sort((field1, field2) => field1.position - field2.position)
      .reduce(
        (jsonProperties, field) => {
          const { name, propertySchema, uiSchema, required } = field
          jsonProperties.properties[name] = propertySchema
          jsonProperties.elements.push(uiSchema)
          jsonProperties.required = jsonProperties.required.concat(required)

          return jsonProperties
        },
        { properties: {}, required: [], elements: [] }
      )

    const fieldValues = this.fields.reduce((valuesByField, field) => {
      const fieldValuesForField = field.getLegacyFieldValues?.()
      if (fieldValuesForField?.length) {
        valuesByField[field.name] = fieldValuesForField
      }
      return valuesByField
    }, {})

    const result = {
      propertySchema: {
        type: 'object',
        properties: jsonProperties.properties,
        required: jsonProperties.required
      },
      uiSchema: {
        type: 'VerticalLayout',
        elements: jsonProperties.elements
      }
    }

    const legacy = { ...this.legacy }
    if (Object.keys(fieldValues).length > 0) {
      legacy.fieldValues = fieldValues
    } else {
      delete legacy.fieldValues
    }

    if (Object.keys(legacy).length > 0) {
      result.legacy = legacy
    }

    return result
  }

  static FromJSON ({
    propertySchema,
    uiSchema,
    legacy
  }) {
    const fieldValues = legacy?.fieldValues
    const fields = Object.keys(propertySchema.properties).map(
      (propertyName, index) => StoreFormField.FromJSONSchema(
        propertyName,
        index,
        propertySchema,
        uiSchema,
        fieldValues
      )
    )

    return new StoreFormConfiguration(
      fields,
      legacy ? { ...legacy } : {}
    )
  }
}

export default StoreFormConfiguration
